import { useMemo } from 'react'

export default function useIsSale() {
  return useMemo(() => {
    const now = new Date()
    return now >= new Date('2026-06-04T16:00:00-04:00') && now < new Date('2026-06-10T00:00:00-04:00')
  }, [])
}
